import { TypedMap } from 'flow/types/TypedMap';
import { CapabilitiesType, Extension } from 'flow/types/Extension';
import { ExtensionKey } from 'flow/types/EntityKeys';
import {
    getBgColorFromContact_TW,
    getBgColorFromKey_TW,
    isExtensionKey,
} from 'flow/utils';
import { Capabilities } from 'flow/utils/capability-utils';
import { extractIndex } from './extension-utils';
import { Contact } from 'flow/types/Contact';

export const filterByAllfileds = (e: TypedMap<Extension>, filter?: string[]) =>
    extractIndex(e, true, false).indexOf(filter.join(' ')) !== -1;

export const isTypeExtensionKey = (key?: string): key is ExtensionKey =>
    isExtensionKey(key);

export const getContactBackgroundColor = (contact: TypedMap<Contact>) => {
    const contactColor = contact.get('key')
        ? getBgColorFromKey_TW(contact.get('key'))
        : getBgColorFromContact_TW(contact);

    return contactColor || 'bg-gray-200';
};

export const getExtensionHasCapability = (
    extension: TypedMap<Extension>,
    capability: CapabilitiesType,
) => !!extension?.hasIn(['capabilities', capability]);

export const hasVideoCapability = (extension: TypedMap<Extension>) =>
    getExtensionHasCapability(extension, Capabilities.VIDEO);
